import React, { useEffect, useState } from 'react'
import axios from 'axios'

import { GrClose } from 'react-icons/gr'
import { useStateValue } from '../../Utils/StateProvider'
import { useCookies } from 'react-cookie'
import { capitalizeWords } from '../../Utils/general'
import { VscCircleLargeFilled } from 'react-icons/vsc'

const Aside = () => {
    const [{ url, customer, activities, showAside }, payload] = useStateValue()
    const [cookies] = useCookies(['bearerToken'])

    const [activity, setActivity] = useState(null)


    const getActivities = async source => {

        try {
            const options = {
                cancelToken: source.token,
                headers: {
                    Authorization: `Bearer ${cookies.bearerToken}`
                }
            }
            const __data = await axios.get(`${url}/api/u/activities`, options)

            payload({
                type: 'SET_ACTIVITIES',
                activities: __data.data.activities
            })
        } catch(err) {
            console.error(err.message)
        }
    }

    const viewActivity = async (source, activity_id) => {
        try {
            const options = {
                headers: {
                    Authorization: `Bearer ${cookies.bearerToken}`
                }
            }
            const activities_update = await axios.patch(`${url}/api/u/activities`, {
                uid: customer?.uid,
                activity_id,
                setters: {
                    viewed: 1
                }
            }, options)

            payload({
                type: 'SET_ACTIVITIES',
                activities: activities_update.data.activities
            })
        } catch(err) {
            console.error(err.message)
        }
    }

    useEffect(() => {
        const source = axios.CancelToken.source()
        getActivities(source)

        return () => {
            source.cancel()
        }
    }, [])

    useEffect(() => {
        const source = axios.CancelToken.source()
        if (activity !== null) viewActivity(source, activity.activity_id)

        return () => {
            source.cancel()
        }
    }, [activity])

    return (
        <div className='aside'>
        {
            activity === null ? (
                <div className="aside-content">
                    <GrClose onClick={() => payload({ type: 'TOGGLE_ASIDE', aside: showAside})} />
                    <div className="activities">
                    {
                        activities.length > 0 ? (
                            <ul className="activities-container">
                            {
                                activities.map((_activity, index) => (
                                    <li 
                                        key={index}
                                        className={_activity.viewed === 0 ? "activities-item not-viewed" : "activities-item"}
                                        onClick={() => setActivity(_activity)}
                                    >
                                        <h3>{capitalizeWords(_activity.activity_type)} {_activity.viewed === 0 && <VscCircleLargeFilled />} </h3>
                                        <p>{`${_activity.activity_note.slice(0, 20)}...`}</p>
                                        <strong>{new Date(_activity.timestamp).toDateString()}</strong>
                                    </li>
                                ))
                            }
                            </ul>
                        ) : (
                            <h5>No activity on this account at this time.</h5>
                        )
                    }
                    </div>
                </div>
            ) : (
                <div className="activity-display">
                    <GrClose onClick={() => payload({ type: 'TOGGLE_ASIDE', aside: showAside})} />
                    <div className="activity-content">
                        <p>{activity.activity_note}</p>
                    </div>
                </div>
            )
        }
        </div>
    )
}

export default Aside
